module.exports = __webpack_public_path__ + "static/mastercard-76b8dd1e0928354758cfcdffa822a5e8.svg";